import Stack from '@mui/material/Stack'
import React, { useState } from 'react'
import { RegisteredCheckBox } from '../../../../components/fields/CheckBox'
import { AdvisorSelect } from '../../../../components/AdvisorSelect'
import { useFormContext } from 'react-hook-form'
import { AdvisorListItem, ConvertibleAdvisorType, IssueAdvisorType } from '@finance-lab/utils/types'
import { CategorizedAdvisor } from './types'

export function AddAdvisorFields<T extends Pick<AdvisorListItem, 'name'>>({
    advisors,
    entityType,
    selectedAdvisors,
    onSelect,
    advisorType,
    setIsCustomFormDirty,
}: {
    advisors: Array<T>
    advisorType: IssueAdvisorType | ConvertibleAdvisorType
    entityType: 'issue' | 'convertible'
    onSelect: (a: CategorizedAdvisor) => void
    selectedAdvisors: Array<CategorizedAdvisor>
    setIsCustomFormDirty: (v: boolean) => void
}) {
    const checkboxName = {
        financial_advisor: 'noFinancialAdvisor',
        legal_advisor: 'noLegalAdvisor',
        issuing_agent: 'noIssuingAgent',
    }
    const formMethods = useFormContext()
    const [checked, setChecked] = useState(!!formMethods.getValues(checkboxName[advisorType]))
    const checkLabels = {
        financial_advisor: 'Inga finansiella rådgivare',
        legal_advisor: 'Inga legala rådgivare',
        issuing_agent: 'Inga emissionsinstitut',
    }
    const selectLabels = {
        financial_advisor: 'Ange ny finansiell rådgivare',
        legal_advisor: 'Ange ny legal rådgivare',
        issuing_agent: 'Ange nytt emissionsinstitut',
    }
    const handleSelect = (advisor: T | { name: string }) => onSelect({ ...advisor, type: advisorType })

    return (
        <Stack spacing={1}>
            <>
                {(!selectedAdvisors || selectedAdvisors.length === 0) && entityType !== 'convertible' && (
                    <RegisteredCheckBox
                        name={checkboxName[advisorType]}
                        label={checkLabels[advisorType]}
                        onChange={(event) => {
                            setChecked(event.target.checked)
                            if (setIsCustomFormDirty) {
                                setIsCustomFormDirty(true)
                            }
                        }}
                    />
                )}
            </>
            <>
                {!checked && (
                    <AdvisorSelect
                        advisors={advisors}
                        label={selectLabels[advisorType]}
                        onSelect={handleSelect}
                        onCreate={handleSelect}
                    />
                )}
            </>
        </Stack>
    )
}
